/* eslint-disable @nx/enforce-module-boundaries */
import React, { useContext, useEffect, useState } from 'react';
import { IconButton } from '@mybridge/ui/icon-button';
import { ChatIcon, NewGroup, ChatDefaultIcon } from '@mybridge/icons';
import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
} from '@mybridge/ui/popover';
import { HStack, Box, Circle } from '@mybridge/ui/layout';
import { Text } from '@mybridge/ui/text';
import ConversationListCard from 'v4/snippets/chat/conversation-card';
import { Button } from '@mybridge/ui/button';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useDisclosure } from '@chakra-ui/hooks';
import { setMeetingWindowed } from 'v4/store/actions/meeting.actions';
import { Badge, Portal } from '@mybridge/ui';
import Link from 'next/link';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import { isMobile } from 'react-device-detect';
import { Tooltip } from '@mybridge/ui';
import { setMainChatNotification } from 'v4/store/actions/chat.actions';
import { useRouter } from 'next/router';
import { getUserRoomList } from 'v4/store/actions/global.data.actions';
// import { io } from 'socket.io-client';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { Spinner } from '@chakra-ui/react';
import { useMessageNotification } from 'packages/mybridgev4/context/message-notification-context';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
import { useChatSocket } from 'packages/mybridgev4/hooks/useChatSocket';
const ConversationList = ({notifDisc, ...props}) => {
  const dispatch = useDispatch();
  const { shouldReduceCount, reductionAmount } = useMessageNotification();
  const { currentMeetingState } = useSelector((state) => state.meeting);
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const {globalNotificationData} = useSelector((state) => state.globalData)
  const { onEvent } = useChatSocket();
  const {
    matrixClient,
    setupMatrixClient,
    teamsChats,
    newChatDisc,
    setConnectionList,
    unreadCount,
    setUnreadCount,
    roomId,
  } = useContext(MatrixContext);
  const chatMenuDisc = useDisclosure();
  const { t } = useTranslator();
  const [chatList, setChatList] = useState([]);
  const [isNavigating, setIsNavigating] = useState(false);
  const [totalNotificationCount, setTotalNotificationCount] = useState(0);
  const router = useRouter();
  const [showCount, setShowCount] = useState(false);
  const [loading, setLoading] = useState(true);
  // const TOKEN_NAME = process.env.BASE_TOKEN_NAME;
  // const socketRef = useRef(null);
  // const SOCKET_SERVER_URL = process.env.SOCKET_URL;
  const { formatNumber } = useNumberFormatter();
  // const accessToken =
  //   typeof window !== 'undefined' && localStorage.getItem(TOKEN_NAME);
  // // Initialize socket connection
  // useEffect(() => {
  //   socketRef.current = io(SOCKET_SERVER_URL, {
  //     extraHeaders: {
  //       token: `${accessToken}`,
  //     },
  //   });

  //   socketRef.current.on('connect', () => {
  //     console.log('Socket connected!');
  //   });

  //   return () => {
  //     socketRef.current.disconnect();
  //   };
  // }, [accessToken]);


  useEffect(() => {
    if (shouldReduceCount > 0) {
      setTotalNotificationCount(prevCount => Math.max(0, prevCount - (reductionAmount || 1)));
    }
  }, [shouldReduceCount, reductionAmount]);
  
  useEffect(()=>{
    if(globalNotificationData){
      setTotalNotificationCount(globalNotificationData?.chat_unread)
    }
  }, [globalNotificationData])


  // This is for update count using 'chat.message' event
  /*
  useEffect(() => {
    if (!socketEvents?.length) return;

    const last = socketEvents[socketEvents.length - 1];

    if (last?.event_name !== 'chat.message' || !last?.is_added) return;

    const msg = last?.event;
    const currentUserId = userProfileInfo?.id;
    const senderId = msg?.sender || msg?.user_id || last?.user_id;
    const messageRoomId = msg?.room_id || msg?.room || last?.room_id;

    if (msg && senderId && currentUserId && senderId !== currentUserId) {
      const isOnMessagePage = router.pathname.includes('/profile/message');

      // If user is on the messages page and currently viewing this room,
      // treat incoming messages as already read and don't increment header count.
      if (isOnMessagePage && roomId && messageRoomId && messageRoomId === roomId) {
        return;
      }

      setTotalNotificationCount((prevCount) => prevCount + 1);
    }
  }, [socketEvents, userProfileInfo?.matrix_user_id]);
  */

  
  useEffect(() => {
    return onEvent('chat.notification', (event) => {
      setTotalNotificationCount(event?.chat_unread || 0);
    });
  }, []);
  
  const fetchRoomList = async (searchQuery = '') => {
    const isOnMessagePage = router.pathname.includes('/profile/message');
    dispatch(getUserRoomList(searchQuery)).then((res) => {
      const rooms = res?.payload?.rooms || [];
      // setConnectionList(res?.payload?.results || []);
      const totalNotifications = rooms?.reduce(
        (sum, room) => sum + (room?.notification_count || 0),
        0
      );      
      setTotalNotificationCount(totalNotifications);
    
      if (!isOnMessagePage) {
        setConnectionList(rooms || []);
      }
    });
  };

  const handleNavigation = () => {
    if (!isNavigating) {
      if (!router.pathname.includes('/profile/message')) {
        setIsNavigating(true);
      }
      router.push(`/profile/message`).finally(() => {
        setIsNavigating(false);
      });
    }
  };

  // useEffect(() => {
  //   if (!router.pathname.includes('/profile/message')) {
  //     fetchRoomList();
  //   }
  // }, [router.query.user, router.pathname]);
  
  return (
    <>
      {isNavigating ? (
        <Box 
          minW="32px"
          borderRadius="full"
          w="32px"
          h="32px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          BoxShadow="0px 0px 10px 0px #00000029;0px 4px 5px 0px #0000000F inset;0px -5px 3px 0px #0000000F inset;"
          bg="#DEDEDE"
        >
          <Spinner size="xs" color="rgb(65, 112, 164)" />
        </Box>
      ):
        <Box onClick={() => handleNavigation()}>
          {/* <Popover placement="bottom-end"> */}
            {/* <PopoverTrigger onClick={() => router.push(`/profile/message`)}> */}
              {!isMobile ? (
                <IconButton
                  bg="transparent"
                  borderRadius="50px"
                  // _hover={{
                  //   backgroundColor: props?.isAuth !=="Auth" && "transparent",
                  // }}
                  position="relative"
                  // px={[1, 2, 8]}
                  size={isMobile ? 'sm' : 'md'}
                  // variant="homeHeaderButtons"
                
                  {...(router?.pathname.includes('/profile/message') 
    ? {
        borderRadius: '50px',
        BoxShadow:"0px 0px 10px 0px #00000029;0px 4px 5px 0px #0000000F inset;0px -5px 3px 0px #0000000F inset;",
         bg:"#DEDEDE"
      }
    : {})}
                >
                  <>
                    {totalNotificationCount > 0 ? (
                      <Badge
                        position="absolute"
                        bg="brandRed.500"
                        color="white"
                        borderRadius="100%"
                        top="0"
                        minW="25px"
                        border="2px solid #ffffff"
                        lineHeight="normal"
                        p="3px 5px"
                        left="50%"
                        zIndex="3"
                      >
                        {formatNumber(totalNotificationCount)}
                      </Badge>
                    ) : (
                      ''
                    )}
                    <Tooltip label={t('common.messenger') || "Messenger"} bg="black" p={2} isDisabled={notifDisc ? notifDisc?.isOpen : false}>
                      <Box
                        as="span"
                        onClick={() => router.push(`/profile/message`)}
                        _hover={{
                          backgroundColor: 'transparent',
                        }}
                      >
                        <ChatIcon
                          color={router.pathname === "/profile/message" ? "rgb(65, 112, 164)" : "#575757"}
                          width={isMobile && !props.width ? '18' : props.width}
                          height={isMobile && !props.height ? '18' : props.height}
                        />
                      </Box>
                    </Tooltip>
                  </>
                </IconButton>
              ) : (
                <IconButton
                  position="relative"
                  minW="32px"
                  borderRadius="full"
                  w="32px"
                  h="32px"
                  BoxShadow="0px 0px 10px 0px #00000029;0px 4px 5px 0px #0000000F inset;0px -5px 3px 0px #0000000F inset;"
                  bg="#DEDEDE"
                >
                  <>
                    {unreadCount > 0 ? (
                      <Badge
                        position="absolute"
                        bg="brandRed.500"
                        color="white"
                        borderRadius="100%"
                        top="0"
                        minW="25px"
                        border="2px solid #ffffff"
                        p="3px 5px"
                        left="50%"
                        zIndex="3"
                      >
                        {unreadCount}
                      </Badge>
                    ) : (
                      ''
                    )}
                    <Tooltip label={t('common.messenger') || "Messenger"} bg="black" p={2}>
                      <Box as="span">
                        <ChatIcon
                          width={isMobile ? '18' : '35'}
                          height={isMobile ? '18' : '35'}
                        />
                      </Box>
                    </Tooltip>
                  </>
                </IconButton>
              )}
            {/* </PopoverTrigger> */}
          {/* </Popover> */}
        </Box>
      }
    </>
  );
};

export default ConversationList;
